export default "__VITE_ASSET__Ay$a_xJk__"